@if (label(); as label) {
  <onyx-input-label [label]="label"></onyx-input-label>
}

<div class="chips" [class.wrap]="wrap() === true" [style.gap.px]="gap()">
  @for (group of displayGroups(); track group.value; let count = $count) {
    @let groupActive = activeGroup() === group.value;
    <ng-container>
      @if (showGroups() ?? count > 1) {
        <onyx-chip
          [chip]="group"
          [active]="groupActive"
          [variant]="groupActive ? 'tertiary' : 'primary'"
          (click)="changeGroup(group.value)"
        ></onyx-chip>
      }

      @if (groupActive || count === 1) {
        @for (chip of group.chips; track chip.value) {
          @let active = activeValues().includes(chip.value);
          @let disabled = !!chip.disabled;
          <onyx-chip
            [chip]="chip"
            [active]="active"
            [variant]="count === 1 ? variant() : 'secondary'"
            [disabled]="disabled"
            (click)="!disabled ? toggleChip(chip, !active) : null"
          ></onyx-chip>
        }

        @if (group.dropdown.length) {
          <onyx-icon-button
            variant="transparent"
            color="black"
            [size]="32"
            icon="arrow-double-down-outlined"
            [onyxDropdownOptions]="group.dropdown"
            [onyxDropdownMultiple]="!single()"
            [onyxDropdownValue]="activeValues()"
            (onyxDropdownSelectedValuesChange)="activeValues.set($event.values)"
            (click)="$event.stopPropagation()"
          ></onyx-icon-button>
        }
      }
    </ng-container>
  }
</div>

<ng-template let-option="option" #optionTemplate>
  <div class="option">
    <span class="f-body-m f-medium">{{ option.name }}</span>
    @if (option.count != null) {
      <span class="count">{{ option.count }}</span>
    }
  </div>
</ng-template>
